import { useEnv } from "./use-env";
import { useSite } from "./use-site";
export var useSupportEmail = function () {
  var site = useSite();
  var env = useEnv();
  return env.SUPPORT_EMAIL || site.supportEmail || '';
};